import { Schema } from "utils/validate-fields";
import { EmpresaModalData } from "./types";

export const getEmpresaPayloadSchema = (isUserGerente: boolean) =>
  new Schema({
    id: Schema.validateField().number(),
    enabled: Schema.validateField().boolean(),
    name: Schema.validateField()
      .required({ message: "Nome da empresa é obrigatório" })
      .string(),
    codigoNova: isUserGerente
      ? Schema.validateField().string()
      : Schema.validateField()
          .required({ message: "Código Nova é obrigatório" })
          .string(),
    email: Schema.validateField()
      .string()
      .email({ message: "E-mail inválido" }),
    telefone: Schema.validateField().string(),
    regionalCustomer: Schema.validateField().object(
      new Schema({
        id: Schema.validateField().number()
      })
    ),
    enabled3cplus: Schema.validateField().boolean(),
    token3cplus: Schema.validateField().string(),
    parentCustomer: Schema.validateField().object(
      new Schema({
        id: Schema.validateField().number()
      })
    ),
    cnpj: Schema.validateField().string(),
    codigoExterno: isUserGerente
      ? Schema.validateField()
          .required({ message: "Código Externo é obrigatório" })
          .string()
      : Schema.validateField().string(),
    comercialUser: Schema.validateField().object(
      new Schema({
        id: Schema.validateField().number()
      })
    )
  });

export const getInitialEmpresaDialog = (
  openedEmpresa?: EmpresaModalData,
  openedCustomerId?: number
): EmpresaModalData => {
  if (openedEmpresa) {
    return {
      id: openedEmpresa.id,
      enabled: openedEmpresa.enabled ?? true,
      name: openedEmpresa.name ?? "",
      codigoNova: openedEmpresa.codigoNova ?? "",
      email: openedEmpresa.email,
      telefone: openedEmpresa.telefone,
      regionalCustomer: openedEmpresa.regionalCustomer
        ? {
            id: openedEmpresa.regionalCustomer.id,
            name: openedEmpresa.regionalCustomer.name
          }
        : { id: Number(openedCustomerId) },
      enabled3cplus: openedEmpresa.enabled3cplus ?? false,
      token3cplus: openedEmpresa.token3cplus,
      parentCustomer: openedEmpresa.parentCustomer,
      cnpj: openedEmpresa.cnpj,
      codigoExterno: openedEmpresa.codigoExterno,
      comercialUser: openedEmpresa.comercialUser
        ? {
            id: openedEmpresa.comercialUser.id,
            name: openedEmpresa.comercialUser.name
          }
        : undefined
    };
  }

  return {
    enabled: true,
    name: "",
    codigoNova: "",
    enabled3cplus: false,
    regionalCustomer: openedCustomerId ? { id: openedCustomerId } : undefined
  };
};
